export default __webpack_public_path__ + "static/media/challenge.3f44b76f.svg";